<template>
<div class="x_box A4">
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <div class="print-header" style="display: flex; justify-content: space-between">
                    <div>
                        <img src="../../assets/company_logo.png" alt="">
                    </div>
                    <div>
                        <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
                        <h2 class="text-center" style="font-weight: bold;">{{company.LatinName}}</h2>
                        <div style="font-size: 13px;">
                            <b>{{$t('address')}}៖ </b>
                            {{$t('home_no')}} {{company.Home}} {{$t('village')}} {{company.Village}} {{$t('commune')}} {{company.Commune}} {{$t('district')}} {{company.District}} {{$t('capital')}} {{company.Capital}}
                        </div>
                        <div style="font-size: 13px;">
                            <b>{{$t('phone_contact')}}</b>
                            {{company.Phone}} <span>{{$t('email')}}</span>: {{company.Email}}
                            <br>
                            លេខអត្តសញ្ញាណកម្មសារពើពន្ធ​អតប (VAT): {{company.TinHead}}-{{company.VatTin}}
                        </div>
                    </div>
                </div>
                <div style="height: 2px; border: 1px solid black; width: 100%; background: black; margin-bottom: 20px"></div>
                <h4 class="text-center">SALE ORDER</h4>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('customer') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.CustomerName}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('phone') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Phone}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">លេខការបញ្ជាលក់</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{invoice.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm">
                            <thead style="background: #b3cce6">
                                <tr>
                                    <th class="text-center" style="width: 50px;">ល.រ <br/>No</th>
                                    <th class="text-center">បរិយាយ <br/> Description of Goods</th>
                                    <th class="text-center">ម៉ាកផលិតផល <br/> Brand</th>
                                    <th class="text-center" style="width: 100px;">ចំនួន <br/> QTY</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}} <br/>  Unit</th>
                                    <th class="text-center" style="width: 100px;">តម្លៃឯកតា <br/> Unit Price</th>
                                    <th class="text-center" style="width: 100px;">ពន្ធ(%) <br/>Tax</th>
                                    <th class="text-center" style="width: 100px;">សរុបរង <br/>Sub Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td>{{ret.BrandName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$money(ret.Price)}}</td>
                                    <td class="text-right">{{$money(ret.TaxLine)}}</td>
                                    <td class="text-right">{{$money(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="7" class="text-right">{{$t('grand_total')}}:</th>
                                    <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="7" class="text-right">{{$t('taxes')}}:</th>
                                    <th class="text-right">{{$money(invoice.TaxVat)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="7" class="text-right">{{$t('total_amount')}}:</th>
                                    <th class="text-right">{{$money(invoice.PaidAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div class="footer" style="padding: 50px;">
                    <div style="display: flex; justify-content: space-between">
                        <div>
                            <p style="margin-left: 20px">ហត្តលេខា​ និងឈ្មោះអ្នកទិញ</p>
                            <p style="margin-left: 10px">Customer's Signature & Name</p>
                        </div>
                        <div class="text-center">
                            <p>ហត្តលេខា​និងឈ្មោះអ្នកលក់</p>
                            <p>Seller's Signature & Name</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data: function(){
            return {
                company: {},
                invoice: {},
                lines: []
            }
        },
        created: function(){
            this.getCompany();
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                this.$api().post('sale/order/find', { Id: id }).then(res => {
                    var data = res.data.Json;
                    this.invoice = data.Header;
                    this.lines = data.Lines;
                }).finally(function(){ loading.hide(); });
            }
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .table-bordered th, .table-bordered td {
        border: 1px solid black;
    }
</style>